import { useEffect } from 'react';
import {
  PartialEventWithRequiredAction,
  useSendAnalytics,
} from 'src/components/AnalyticsProvider/useSendAnalytics';

export interface UseInProgressModalAnalytics {
  sendAnalyticsBefore: (
    cb: () => void,
    eventData: PartialEventWithRequiredAction
  ) => void;
}

export const useInProgressModalAnalytics = (): UseInProgressModalAnalytics => {
  const { sendAnalytics, sendAnalyticsBefore } = useSendAnalytics({
    eventcategory: 'self-service management tool_orderhistory',
    eventlabel: 'success',
  });

  useEffect(() => {
    sendAnalytics({ eventaction: 'in progress receipts download_impression' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    sendAnalyticsBefore,
  };
};
